import { render, staticRenderFns } from "./jg_visualization_myStatistics.vue?vue&type=template&id=0d990849"
import script from "./jg_visualization_myStatistics.vue?vue&type=script&lang=js"
export * from "./jg_visualization_myStatistics.vue?vue&type=script&lang=js"
import style0 from "./jg_visualization_myStatistics.vue?vue&type=style&index=0&id=0d990849&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports